export const interviewStatuses = {
  DRAFT: 'draft',
  REVIEW_AGENCY: 'review_agency',
  REVIEW_ADMIN: 'review_admin',
  APPROVED: 'approved'
};

export const userRoles = {
  AGENCY: 4,
};
